export type ApiActualEvidence = {
  mapping_config: Record<string, unknown>;
  frequency: string;
  observed_at: string;
  verified_values: Record<string, number>;
};

type Config = { resource?: string; queueStatus?: string; [key: string]: unknown } | null | undefined;

export const isCurrentQueueSnapshot = (config: Config) =>
  config?.resource === "process_queue_count" && config.queueStatus !== "done";

export function getKpiReportingDate(referenceDate: Date, frequency: string, config?: Config): Date {
  if (isCurrentQueueSnapshot(config) || !["monthly", "quarterly"].includes(frequency)) return referenceDate;
  const periodStart = new Date(referenceDate.getFullYear(),
    frequency === "quarterly" ? Math.floor(referenceDate.getMonth() / 3) * 3 : referenceDate.getMonth(), 1);
  const periodEnd = new Date(periodStart.getFullYear(), periodStart.getMonth() + (frequency === "quarterly" ? 3 : 1), 0);
  if (periodEnd <= referenceDate) return referenceDate;
  periodStart.setDate(0);
  return periodStart;
}

export function verifiedSnapshotHistory(
  history: Record<string, number | undefined>, evidence: ApiActualEvidence | null | undefined,
  config: Config, frequency: string,
): Record<string, number | undefined> {
  if (!isCurrentQueueSnapshot(config)) return history;
  if (!evidence || evidence.frequency !== frequency || !Number.isFinite(Date.parse(evidence.observed_at))) return {};
  const fields = ["resource", "provider", "metric", "processId", "queueId", "processSearch", "queueSearch", "queueStatus"];
  if (fields.some((field) => String(evidence.mapping_config?.[field] ?? "") !== String(config?.[field] ?? ""))) return {};
  // Keep old history stored, but never display a former mapping's measurements
  // as today's current process count. Only this mapping's verified values qualify.
  return Object.fromEntries(Object.entries(evidence.verified_values || {})
    .filter(([key, value]) => Number.isFinite(value) && history[key] === value));
}
